<template>
  <div>
    <!-- <el-input
      v-model="config.studentName"
      style="width: 200px;margin-bottom: 10px;"
      clearable
      placeholder="请输入考生姓名"
      @clear="handleCurrentChange(1)"> -->
    <div style="text-align:right;margin-bottom: 10px;">
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="handleCurrentChange(1)">刷新</el-button>
    </div>
    <!-- </el-input> -->
    <el-table
      border
      :data="list">
      <el-table-column
        label="姓名"
        min-width="140"
        prop="studentName">
      </el-table-column>
      <el-table-column
        label="手机号"
        width="140"
        prop="mobilePhone">
      </el-table-column>
      <el-table-column
        label="身份证"
        width="200"
        prop="idCardNo">
      </el-table-column>
      <el-table-column
        label="状态"
        width="100"
        prop="status">
        <template slot-scope="{ row }">{{ row.status | studentRegStatusName() }}</template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="text-align: center;"
      background
      :current-page.sync="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="total"
      @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>
<script>
export default {
  name: 'StudentRegTable',
  props: {
    id: { type: [Number, null], default: null }
  },
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 20, studentName: '' }
    }
  },
  mounted() {
    this.getlist()
  },
  methods: {
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$$examApi.getexamregistrations({ ...this.config, examId: this.id })
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if ([0, 13].includes(result)) {
            this.loading = false
            this.total = total
            this.list = records
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
